import { isPedidoStatusAmostraPendente } from '../../../../pedido/status/amostra/pedido-status-amostra';

/** Tipos de Venda dos Pedidos */
export interface ConfigPedidoTipoVendaIndicador {
    id: number;
    nome: string;
    abreviacao: string;
    sinonimo: string;

    // Amostra Pendente
    nomeAmostraPendente?: string;
    abreviacaoAmostraPendente?: string;
}

export const venda: ConfigPedidoTipoVendaIndicador = {
    id: 1,
    nome: 'Venda',
    abreviacao: 'V',
    sinonimo: 'Pedido'
};
export const bonificacao: ConfigPedidoTipoVendaIndicador = {
    id: 2,
    nome: 'Bonificação',
    abreviacao: 'B',
    sinonimo: 'Pedido'
};
export const amostra: ConfigPedidoTipoVendaIndicador = {
    id: 3,
    nome: 'Amostra',
    abreviacao: 'A',
    sinonimo: 'Pedido',
    // Pendente
    nomeAmostraPendente: 'Amostra Pendente',
    abreviacaoAmostraPendente: 'AP'
};
export const consignacao: ConfigPedidoTipoVendaIndicador = {
    id: 4,
    nome: 'Consignação',
    sinonimo: 'Pedido',
    abreviacao: 'C'
};
export const remessa: ConfigPedidoTipoVendaIndicador = {
    id: 5,
    nome: 'Remessa',
    sinonimo: 'Pedido',
    abreviacao: 'R'
};
export const simulacao: ConfigPedidoTipoVendaIndicador = {
    id: 6,
    nome: 'Simulação',
    sinonimo: 'Simulação',
    abreviacao: 'S'
};
export const orcamento: ConfigPedidoTipoVendaIndicador = {
    id: 7,
    nome: 'Orçamento',
    sinonimo: 'Orçamento',
    abreviacao: 'OC'
};
export const tipoVendaOutro: ConfigPedidoTipoVendaIndicador = {
    id: 99,
    nome: 'Outro',
    sinonimo: 'Pedido',
    abreviacao: 'O'
};

export const tiposVenda: ConfigPedidoTipoVendaIndicador[] = [
    venda,
    bonificacao,
    amostra,
    consignacao,
    remessa,
    simulacao,
    orcamento,
    tipoVendaOutro
];


/** Obtem o indicador do tipo de venda do pedido */
export function getTipoVendaIndicador(id: number): ConfigPedidoTipoVendaIndicador {
    switch (id) {
        case venda.id:
            return venda;
        case bonificacao.id:
            return bonificacao;
        case amostra.id:
            return amostra;
        case consignacao.id:
            return consignacao;
        case remessa.id:
            return remessa;
        case simulacao.id:
            return simulacao;
        case orcamento.id:
            return orcamento;
        case tipoVendaOutro.id:
            return tipoVendaOutro;
    }
    return null;
}


/** Verifica se o tipo de venda do pedido é igual a Venda */
export function isVenda(tipo: number): boolean {
    return tipo === venda.id;
}

/** Verifica se o tipo de venda do pedido é igual a Bonificação */
export function isBonificacao(tipo: number): boolean {
    return tipo === bonificacao.id;
}

/** Verifica se o tipo de venda do pedido é igual a Amostra */
export function isAmostra(tipo: number): boolean {
    return tipo === amostra.id;
}

/** Verifica se o tipo de venda do pedido é igual a Amostra e está pendente */
export function isAmostraPendente(tipo: number, statusAmostra: number = null): boolean {
    return isAmostra(tipo) && isPedidoStatusAmostraPendente(statusAmostra);
}


/** Verifica se o tipo de venda do pedido é igual a Consignacao */
export function isConsignacao(tipo: number): boolean {
    return tipo === consignacao.id;
}

/** Verifica se o tipo de venda do pedido é igual a Remessa */
export function isRemessa(tipo: number): boolean {
    return tipo === remessa.id;
}

/** Verifica se o tipo de venda do pedido é igual a Simulação */
export function isSimulacao(tipo: number): boolean {
    return tipo === simulacao.id;
}

/** Verifica se o tipo de venda do pedido é igual a Orçamento */
export function isOrcamento(tipo: number): boolean {
    return tipo === orcamento.id;
}

/** Verifica se o tipo de venda do pedido é igual a Outro */
export function isTipoVendaOutro(tipo: number): boolean {
    return tipo === tipoVendaOutro.id;
}

